// Baut den EVE-Prompt fuer die Trending-Coin-Recherche. Statt EVE selbst
// "suchen" zu lassen (kann sie nicht — Live-Search ist in V3 aus), holt die
// Page vorab echte Web-Suchergebnisse via /serp und packt sie hier in den
// Prompt. EVE fasst NUR diesen Coin zusammen — kein Makro-Dump.

import type { SerpSearchResult } from './serp-api';

export interface TrendingCoinRef {
  symbol: string;
  name: string;
}

const MAX_RESULTS = 6;

function pickResults(res: SerpSearchResult | null): Array<{ title: string; snippet?: string; link?: string }> {
  if (!res) return [];
  const list = res.organic_results ?? res.organic ?? [];
  return list.filter((r) => r && r.title).slice(0, MAX_RESULTS);
}

const FOCUS_RULES =
  'WICHTIG: Es geht NUR um diesen einen Coin und warum er gerade trending ist. ' +
  'KEIN allgemeiner Gesamtmarkt- oder Makro-Ueberblick (BTC/DXY/VIX/Carry-Trade usw.) — ' +
  'das ist hier irrelevant. Keine erfundenen Kurse oder Zahlen. Strukturiert und auf den Punkt.';

export function buildTrendingPrompt(coin: TrendingCoinRef, res: SerpSearchResult | null): string {
  const results = pickResults(res);

  if (results.length === 0) {
    return (
      `Der Coin ${coin.symbol} (${coin.name}) steht gerade auf CoinGecko in den Trending-Coins. ` +
      `Ich konnte dazu keine Web-Suchergebnisse abrufen.\n\n` +
      `Aufgabe: Sag ehrlich, dass du ohne Live-Suche keinen konkreten aktuellen Ausloeser kennst. ` +
      `Gib eine kurze Einordnung der Coin aus deinem Wissen (was ist das, eher Hype oder Substanz) ` +
      `und eine knappe Trade-Einschaetzung.\n\n${FOCUS_RULES}`
    );
  }

  const formatted = results
    .map((r, i) => {
      const snippet = r.snippet ? ` — ${r.snippet}` : '';
      const link = r.link ? ` (${r.link})` : '';
      return `[${i + 1}] ${r.title}${snippet}${link}`;
    })
    .join('\n');

  return (
    `Der Coin ${coin.symbol} (${coin.name}) steht gerade auf CoinGecko in den Trending-Coins. ` +
    `Finde heraus WARUM. Hier sind aktuelle Web-Suchergebnisse zu genau diesem Coin:\n\n` +
    `${formatted}\n\n` +
    `Aufgabe:\n` +
    `- Erklaere konkret, warum dieser Coin gerade gefragt/trending ist (News, Katalysator, Pump, ` +
    `Influencer-Aktivitaet) — auf Basis DIESER Suchergebnisse.\n` +
    `- Kurze Einordnung der Coin selbst (was ist das, Substanz oder reiner Hype).\n` +
    `- Eine klare Trade-Einschaetzung in 1-2 Saetzen.\n\n` +
    `Wenn die Suchergebnisse keinen klaren Grund zeigen, sag das ehrlich statt zu spekulieren. ` +
    `${FOCUS_RULES}`
  );
}

/** Such-Query fuer einen Trending-Coin. */
export function trendingSearchQuery(coin: TrendingCoinRef): string {
  return `${coin.name} ${coin.symbol} crypto coin warum trending pump news`;
}
